<template>
  <a-layout style="background: #fff">
    <Header />
    <div class="header-title">
      <span>获取重定向（转链）之后的 URL</span>
    </div>
    <div class="container">
      <a-form style="text-align: center">
        <a-form-item>
          <a-textarea
            size="large"
            v-model="text"
            allow-clear
            placeholder="原 URL"
            rows="20"
          />
        </a-form-item>
        <a-form-item>
         <div>
          <a-button
            @click="handleQuote"
            type="primary"
            :loading="loading"
          >
            转换 -&gt;
            <span v-if="process_count > 0">({{ process_count }} / {{ total_urls }})</span>
          </a-button>
         </div>
        </a-form-item>
        <a-form-item>
          <a-textarea
            size="large"
            v-model="result_text"
            allow-clear
            placeholder="重定向地址"
            rows="20"
          />
        </a-form-item>
      </a-form>
    </div>
    <Footer />
  </a-layout>
</template>

<script>
import Footer from "../components/Footer";
import Header from "../components/Header";


export default {
  name: "Quote",
  props: {
    query: String,
  },
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      total_urls: 0,
      process_count: 0,
      loading: false,
      text: "",
      result_text: "",
    };
  },
  mounted () {
    if(this.query) {
      this.text = this.query
    }
    document.title = "不便利 - 转链大师"
  },
  watch: {},
  computed: {},
  methods: {
    handleQuote: async function () {
      this.loading = true;
      let urls = this.text.split('\n');
      this.total_urls = urls.length;
      urls = urls.filter(url => url.trim().length > 0);
      if(urls.length === 0) {
        this.$error({
          title: "输入错误",
          content: "请输入要转换的 URL",
        });
        return;
      }

      // 分批转链，每次请求 5 个
      const batchSize = 5;
      let result = '';
      for(let i = 0; i < urls.length; i += batchSize) {
        const batchUrls = urls.slice(i, i + batchSize);
        this.process_count += batchUrls.length;
        try {
          const resp = await this.$http.post("/api/tools/redirects",{}, {
            urls:  batchUrls.join("\n"),
          })
          result += resp.data.data.urls.join('\n') + '\n';
          this.result_text = result;
        } catch (e) {
          const errmsg = e.response.data
            ? JSON.stringify(e.response.data.error)
            : e.toString();
          this.loading = false;
          this.$error({
            title: "网络错误",
            content: errmsg,
          });
        }
       
      }
      this.loading = false;

    },
  },
};
</script>

<style scoped lang="less">



</style>
